import React, { act, useState } from "react";
import {
  Box,
  Avatar,
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  Divider,
  Container,
} from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import ProfileDetail from "./profile-components/profile-detail";
import Following from "./profile-components/following";
import MyVanity from "./profile-components/my-vanity";
import UserSettings from "./profile-components/settings";

const states = ["Maharashtra", "Gujarat", "Delhi", "Rajasthan", "Karnataka"];

const menuItems = [
  {
    key: "profile",
    label: "Profile",
    icon: <PersonOutlineOutlinedIcon fontSize="small" />,
  },
  {
    key: "settings",
    label: "Settings",
    icon: <SettingsOutlinedIcon fontSize="small" />,
  },
  {
    key: "following",
    label: "Following List",
    icon: <GroupOutlinedIcon fontSize="small" />,
  },
  {
    key: "vanity",
    label: "My Vanity",
    icon: <ShoppingBagOutlinedIcon fontSize="small" />,
  },
];

export default function MyProfile() {
  const [activeTab, setActiveTab] = useState("profile");
 



  return (
    <Container
      disableGutters
      sx={{ px: 5, Width: "70%" }}
      //   sx={{
      //     minHeight: "100vh",
      //     bgcolor: "#f7f7f7",
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     px: 2,
      //     py: 4,
      //   }}
    >
      <Box
        sx={{
          //   width: "100%",
          //   maxWidth: 1080,
          borderRadius: 4,
          //   bgcolor: "#fff",
          p: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{ justifyContent: { xs: "flex-start", md: "flex-start" } }}
          >
            <Avatar
              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200"
              alt="profile"
              sx={{ width: 58, height: 58 }}
            />
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                  color: "#111",
                }}
              >
                Manisha Subhanker
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#8a8a8a", mt: 0.5, fontSize: "0.9rem" }}
              >
                +91 - 95636 98563
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box>
          <Button
            startIcon={<LogoutOutlinedIcon />}
            sx={{
              textTransform: "none",
              color: "#ff6f6f",
              bgcolor: "#fff1f1",
              borderRadius: 999,
              px: 2.5,
              py: 1,
              "&:hover": {
                bgcolor: "#ffe7e7",
              },
            }}
          >
            Log Out
          </Button>
        </Box>
      </Box>

      <Box sx={{p: { xs: 2, sm: 3, md: 4 },
          display: "flex",
          justifyContent: "flex-start",}}>
        <Box sx={{width:'15%'}}>
          <Stack spacing={1}>
            {menuItems.map((item) => {
              const active = activeTab === item.key;
              return (
                <Button
                  key={item.key}
                  onClick={() => setActiveTab(item.key)}
                  startIcon={item.icon}
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    borderRadius: 999,
                    px: 2,
                    py: 1.2,
                    width: "100%",
                    color: active ? "#ff6f8e" : "#777",
                    bgcolor: active ? "#fdecef" : "transparent",
                    fontWeight: 400,
                    "&:hover": {
                      bgcolor: active ? "#fdecef" : "#f8f8f8",
                    },
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </Stack>
        </Box>
        <Box sx={{width:'528px',marginLeft:'100px'}}>
      {activeTab === "profile" && <ProfileDetail/>}
           {activeTab === "following" && <Following/>}
            { activeTab === "vanity" && <MyVanity/>}
            {activeTab === "settings" && <UserSettings/>}
        </Box>
      </Box>

      {/* <Grid container spacing={{ xs: 3, md: 10 }}>
          <Grid item xs={12} md={4}>
            <Stack spacing={3}>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ justifyContent: { xs: "flex-start", md: "flex-start" } }}
              >
                <Avatar
                  src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200"
                  alt="profile"
                  sx={{ width: 58, height: 58 }}
                />
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontSize: "1.1rem",
                      lineHeight: 1.2,
                      color: "#111",
                    }}
                  >
                    Manisha Subhanker
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#8a8a8a", mt: 0.5, fontSize: "0.9rem" }}
                  >
                    +91 - 95636 98563
                  </Typography>
                </Box>
              </Stack>

              <Stack spacing={1}>
                {menuItems.map((item) => {
                  const active = activeTab === item.key;
                  return (
                    <Button
                      key={item.key}
                      onClick={() => setActiveTab(item.key)}
                      startIcon={item.icon}
                      sx={{
                        justifyContent: "flex-start",
                        textTransform: "none",
                        borderRadius: 999,
                        px: 2,
                        py: 1.2,
                        width: "100%",
                        color: active ? "#ff6f8e" : "#777",
                        bgcolor: active ? "#fdecef" : "transparent",
                        fontWeight: 400,
                        "&:hover": {
                          bgcolor: active ? "#fdecef" : "#f8f8f8",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={8}>
            <Stack
              direction="row"
              justifyContent={{ xs: "flex-start", sm: "flex-end" }}
              sx={{ mb: 3 }}
            >
              <Button
                startIcon={<LogoutOutlinedIcon />}
                sx={{
                  textTransform: "none",
                  color: "#ff6f6f",
                  bgcolor: "#fff1f1",
                  borderRadius: 999,
                  px: 2.5,
                  py: 1,
                  "&:hover": {
                    bgcolor: "#ffe7e7",
                  },
                }}
              >
                Log Out
              </Button>
            </Stack>

            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2.4}>
                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    Name
                  </Typography>
                  <TextField
                    fullWidth
                    value={formData.name}
                    onChange={handleChange("name")}
                    size="small"
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    Enter Mobile Number
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={formData.mobile}
                    onChange={handleChange("mobile")}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography sx={{ fontSize: "1rem" }}>🇬🇧</Typography>
                            <Typography sx={{ fontSize: "0.95rem", color: "#111" }}>
                              {formData.countryCode}
                            </Typography>
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{ height: 20, alignSelf: "center" }}
                            />
                          </Stack>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    Age
                  </Typography>
                  <TextField
                    fullWidth
                    value={formData.age}
                    onChange={handleChange("age")}
                    size="small"
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    Occupation{" "}
                    <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
                      (Optional)
                    </Box>
                  </Typography>
                  <TextField
                    fullWidth
                    value={formData.occupation}
                    onChange={handleChange("occupation")}
                    size="small"
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    State{" "}
                    <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
                      (Optional)
                    </Box>
                  </Typography>
                  <TextField
                    select
                    fullWidth
                    value={formData.state}
                    onChange={handleChange("state")}
                    size="small"
                    SelectProps={{
                      IconComponent: KeyboardArrowDownOutlinedIcon,
                    }}
                  >
                    {states.map((state) => (
                      <MenuItem key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Box>
                  <Typography
                    sx={{ mb: 0.8, fontSize: "0.9rem", fontWeight: 500, color: "#111" }}
                  >
                    Pincode{" "}
                    <Box component="span" sx={{ color: "#999", fontWeight: 400 }}>
                      (Optional)
                    </Box>
                  </Typography>
                  <TextField
                    fullWidth
                    value={formData.pincode}
                    onChange={handleChange("pincode")}
                    size="small"
                  />
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 1,
                    bgcolor: "#000",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: 2,
                    py: 1.4,
                    fontWeight: 500,
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "#111",
                      boxShadow: "none",
                    },
                  }}
                >
                  Save Changes
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid> */}
    </Container>
  );
}
